import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TimeFrameInputDto, TimeFrameTypeDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class TimeFrameRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  getTimeFrameWithoutPatient(patientId: string, visitId: string, timeFrameTypeDto: TimeFrameInputDto): Observable<TimeFrameTypeDto> {
    const endpointUrl = `patients/${patientId}/visit/${visitId}/fnd/timeframe/nonpatient`;
    return this.httpClientService.sendPostRequest(endpointUrl, timeFrameTypeDto);
  }

  getTimeFrameWithPatient(patientId: string, visitId: string, timeFrameTypeDto: TimeFrameInputDto): Observable<TimeFrameTypeDto> {
    const endpointUrl = `patients/${patientId}/visit/${visitId}/fnd/timeframe/patient`;
    return this.httpClientService.sendPostRequest(endpointUrl, timeFrameTypeDto);
  }
}
